import { CommonModule, PlatformLocation } from '@angular/common';
import { Component } from '@angular/core';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { AbstractControl, FormControl, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, Validators } from '@angular/forms';
import { DevicesService } from '../../../services/devices.service';
import { LoginUserModel } from '../../../models/loginUserModel';
import { read, utils, WorkBook, WorkSheet } from 'xlsx';
import { Device } from '../../../models/device';
import { LoaderComponent } from '../../../utils/loader/loader.component';
import { Title } from '@angular/platform-browser';
import { ThemeService } from '../../../theme.service';
import { Router } from '@angular/router';
import { NoMatch } from '../../../matchValidator';
import { ContactInfo, ContactInfoService } from '../../../services/contact-info.service';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { SelectButtonModule } from 'primeng/selectbutton';

import { DialogModule } from 'primeng/dialog';
import { ToastService } from '../../../services/toast.service';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-new-device',
  imports: [
    NgxMaskDirective, CommonModule, ReactiveFormsModule, FormsModule,
    LoaderComponent, TableModule, ButtonModule, InputTextModule,    TooltipModule, // 2. Add it to imports
    
    ToggleSwitchModule, SelectButtonModule, DialogModule
  ],
  templateUrl: './new-device.component.html',
  styleUrl: './new-device.component.scss',
  providers: [provideNgxMask()]
})
export class NewDeviceComponent {
  devices: any[] = [];
  foundedPlates: any[] = [];
  headers = [
    { key: 'driver', textHeader: 'Usuario' },
    { key: 'device', textHeader: 'Vehículo' },
    { key: 'plates', textHeader: 'Placas' },
    { key: 'ecoNumber', textHeader: 'Num económico' },
    { key: 'department', textHeader: 'Departamento' },
    { key: 'maxConsumption', textHeader: 'Consumo max' },
    { key: 'product', textHeader: 'Combustible' },
    { key: 'hologram', textHeader: 'Holograma' }
  ];
  formDevice!: FormGroup;
  messageError = '';
  selectedDevice: any;
  deliveryMethod = '';
  showMessageError = false;
  hideForm = false;
  importedDevices: any[] = [];
  isSaving = false;
  showModalFile = false;
  showAlert = false;
  requireHologram = false;

  allProducts = [
    { value: 1, product: 'Regular' },
    { value: 2, product: 'Supreme' },
    { value: 3, product: 'Diesel' }
  ];

  data!: LoginUserModel;
  contact!: ContactInfo;
  cardProducts: any[] = [];

  public inputTransformFn = (value: unknown): string => String(value).toUpperCase();
  public outputTransformFn = (value: string | number | undefined | null): string => String(value).toUpperCase();
  pattern = { K: { pattern: new RegExp('[A-Z0-9\\-]'), optional: true } };

  constructor(
    private service: DevicesService,
    private titleService: Title,
    private themeService: ThemeService,
    private router: Router,
    private platformLocation: PlatformLocation,
    private toastSrv: ToastService,
    private contactSvc: ContactInfoService
  ) {
    this.titleService.setTitle('Alta Dispositivo');
    this.themeService.setTitle('Alta Dispositivos');
    this.data = JSON.parse(localStorage.getItem('data')!);
    this.contactSvc.get().subscribe(c => this.contact = c);
    platformLocation.onPopState(() => { this.showAlert = true; });
  }

  ngOnInit() {
    this.getAllPlates();
    this.formDevice = new FormGroup({
      driverName: new FormControl('', [Validators.required]),
      brandModel: new FormControl('', [Validators.required]),
      plate1: new FormControl('', [Validators.required]),
      plate2: new FormControl(''),
      ecoNumber: new FormControl(''),
      department: new FormControl(''),
      maxConsumption: new FormControl('', [Validators.required, Validators.min(1)]),
      requireHologram: new FormControl(false),
    }, { validators: NoMatch('plate1', 'plate2') });
  }

  get f() { return this.formDevice.controls; }
  get plate1() { return this.formDevice.get('plate1'); }
  get plate2() { return this.formDevice.get('plate2'); }

  tieneProducto(v: number) { return this.cardProducts.findIndex(p => p.value === v) > -1; }
  tieneProductoText(v: number, code: string) { return code.includes(v.toString()); }

  addProduct(product: any) {
    if (this.tieneProducto(3) && (product.value === 1 || product.value === 2)) {
      this.cardProducts = [this.allProducts.find(e => e.value === product.value)!];
    } else if ((this.tieneProducto(1) || this.tieneProducto(2)) && product.value === 3) {
      this.cardProducts = [this.allProducts.find(e => e.value === product.value)!];
    } else {
      const idx = this.cardProducts.findIndex(p => p.value === product.value);
      if (idx > -1 && this.cardProducts.length > 1) this.cardProducts.splice(idx, 1);
      else if (idx === -1) this.cardProducts.push(this.allProducts.find(e => e.value === product.value)!);
    }
  }

  clickOnRemove(item: any) {
    const idx = this.devices.findIndex(e => e.id === item.id);
    if (idx > -1) this.devices.splice(idx, 1);
    this.toastSrv.add({ type: 'info', message: 'Dispositivo eliminado de la lista' });
  }

  backButton() {
    this.devices.length > 0 ? this.showAlert = true : this.goBack();
  }

  goBack() { this.router.navigate(['app/dispositivos']); }

  addDevice() {
    if (this.validatePlate(this.plate1!.value)) {
      this.toastSrv.add({ type: 'error', message: 'Las placas ' + this.plate1!.value + ' ya se encuentran registradas' });
      return;
    }
    if (this.plate2!.value && this.plate2!.value.trim() !== '' && this.validatePlate(this.plate2!.value)) {
      this.toastSrv.add({ type: 'error', message: 'Las placas ' + this.plate2!.value + ' ya se encuentran registradas' });
      return;
    }

    this.showMessageError = false;
    const newDevice = {
      id: this.devices.length + 1,
      driver: this.formDevice.get('driverName')!.value,
      device: this.formDevice.get('brandModel')!.value,
      plate1: this.f['plate1'].value,
      plate2: this.f['plate2'].value || '',
      plates: this.plate2?.value?.trim() ? this.plate1?.value + ' / ' + this.plate2?.value : this.plate1?.value,
      ecoNumber: this.formDevice.get('ecoNumber')!.value,
      department: this.formDevice.get('department')!.value,
      maxConsumption: this.formDevice.get('maxConsumption')?.value + ' Lts',
      maxLiters: this.formDevice.get('maxConsumption')?.value,
      product: this.getSelectedProductsText(),
      products: this.getSelectedProducts(),
      hologram: this.formDevice.get('requireHologram')!.value ? 'Si' : 'No',
      requireHologram: this.formDevice.get('requireHologram')!.value,
    };

    this.devices.push(newDevice);
    this.formDevice.reset();
    this.cardProducts = [];
    this.toastSrv.add({ type: 'success', message: 'Dispositivo agregado a la solicitud' });
  }

  getSelectedProductsText() {
    const parts: string[] = [];
    if (this.tieneProducto(1)) parts.push('Regular');
    if (this.tieneProducto(2)) parts.push('Supreme');
    if (this.tieneProducto(3)) parts.push('Diesel');
    return parts.join(' - ');
  }

  getSelectedProducts() {
    let p = '';
    if (this.tieneProducto(1)) p += '1';
    if (this.tieneProducto(2)) p += '2';
    if (this.tieneProducto(3)) p += '3';
    return p;
  }

  getAllPlates() {
    this.service.getPlatesByClient(this.data.Client_number).subscribe({
      next: (resp: any) => { this.foundedPlates = resp; },
      error: () => { this.foundedPlates = []; }
    });
  }

  existPlate(event: any) {
    const val = event.target.value.trim();
    if (!val) { this.showMessageError = false; this.messageError = ''; return; }
    if (this.validatePlate(val)) {
      this.messageError = 'Las placas ' + val + ' ya se encuentran registradas';
      this.showMessageError = true;
    } else {
      this.messageError = '';
      this.showMessageError = false;
    }
  }

  validatePlate(plate: string) {
    return this.foundedPlates.some(e => e.platesName.toUpperCase() === plate.toUpperCase())
      || this.devices.some(e => e.plate1.toUpperCase() === plate.toUpperCase() || (e.plate2 && e.plate2.toUpperCase() === plate.toUpperCase()));
  }

  searchHQR() { return this.devices.some(d => d.requireHologram); }

  showModalUpload() { this.showModalFile = true; }

  getMasiveSelectedProductsText(code: string) {
    const parts: string[] = [];
    if (this.tieneProductoText(1, code)) parts.push('Regular');
    if (this.tieneProductoText(2, code)) parts.push('Supreme');
    if (this.tieneProductoText(3, code)) parts.push('Diesel');
    return parts.join(' - ');
  }

  onFileChange(evt: any) {
    this.showModalFile = false;
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) {
      this.toastSrv.add({ type: 'error', message: 'No puedes seleccionar más de 1 archivo' });
      return;
    }
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      const wb: WorkBook = read(e.target.result);
      const ws: WorkSheet = wb.Sheets[wb.SheetNames[1]];
      this.importedDevices = <any>(utils.sheet_to_json(ws, { header: 1 }));
      const header = this.importedDevices[0];
      if (!header || header[0]?.toLowerCase() !== 'usuario') {
        this.toastSrv.add({ type: 'error', message: 'El archivo no contiene el formato correcto' });
        return;
      }
      let errors = '';
      this.importedDevices.slice(1).forEach((element, i) => {
        const cells = element;
        let hasError = false;
        if (!cells.length) { errors += `[fila:${i + 1}] sin datos. `; return; }
        if (!cells[0]) { errors += `[fila:${i + 1}] Usuario vacío. `; hasError = true; }
        if (!cells[1]) { errors += `[fila:${i + 1}] Vehículo vacío. `; hasError = true; }
        if (!cells[2]) { errors += `[fila:${i + 1}] Placas vacías. `; hasError = true; }
        if (cells[2]) {
          cells[2].split('/').forEach((p: string) => {
            if (this.validatePlate(p.trim())) { errors += `[fila:${i + 1}] Placa ${p.trim()} ya registrada. `; hasError = true; }
          });
        }
        if (isNaN(cells[5])) { errors += `[fila:${i + 1}] Consumo debe ser número. `; hasError = true; }
        const validFuels = ['regular', 'diesel', 'supreme', 'regular y supreme'];
        if (!cells[6] || !validFuels.includes(cells[6].toString().toLowerCase())) { errors += `[fila:${i + 1}] Combustible inválido. `; hasError = true; }
        else {
          const map: any = { 'regular': '1', 'supreme': '2', 'diesel': '3', 'regular y supreme': '12' };
          element[6] = map[cells[6].toLowerCase()] || cells[6];
        }
        if (!cells[7] || !['si', 'no'].includes(cells[7].toString().toLowerCase())) { errors += `[fila:${i + 1}] Dispositivo debe ser "si" o "no". `; hasError = true; }

        if (!hasError) {
          const plates = cells[2].split('/');
          this.devices.push({
            id: this.devices.length + 1, driver: element[0], device: element[1],
            plate1: plates[0].toUpperCase(), plate2: plates.length > 1 ? plates[1].toUpperCase() : '',
            plates: element[2], ecoNumber: element[3], department: element[4],
            maxConsumption: element[5] + ' Lts', maxLiters: parseInt(element[5]),
            product: this.getMasiveSelectedProductsText(element[6]), products: element[6],
            hologram: element[7].toLowerCase() === 'si' ? 'Si' : 'No',
            requireHologram: element[7].toLowerCase() === 'si'
          });
        }
      });
      if (errors) this.toastSrv.add({ type: 'error', message: errors });
      else this.toastSrv.add({ type: 'success', message: this.importedDevices.length - 1 + ' dispositivos cargados' });
    };
    reader.readAsArrayBuffer(target.files[0]);
    evt.target.value = '';
  }

  saveDevices() {
    if (this.searchHQR() && !this.deliveryMethod) {
      this.toastSrv.add({ type: 'error', message: 'Debes seleccionar el método de entrega' });
      return;
    }
    if (this.devices.length === 0) return;

    this.isSaving = true;
    const devicesRequest: Device[] = this.devices.map(el => ({
      card_id: 0, cardId: 0, groupId: 0, number: 0, clientId: this.data.Client_id,
      clientNumber: this.data.Client_number, password: '', passwordApp: '', status: 1,
      cardStatus: 'A', message: '', deviceType: el.requireHologram ? 'HQR' : 'TV',
      isMaster: 0, stationMessage: '', product: el.products, name: el.driver,
      description: el.device, department: el.department, account: '', economicNumber: '',
      odometer: '', lastOdometer: 0, plates: el.plate1, plateUpdateDate: new Date(),
      plate2UpdateDate: new Date(), plates2: '', plateId: 0, allowSavePlates: false,
      saleGallos: false, allowOtherPlates: false, checkDigit: '', ring: '',
      digitSecurity: '', sign: '', photoRequired: 0, videoLoad: '', enableVideoButton: '',
      smsRequired: 0, userCellphone: '', dailyLimitLiters: 0, dailyLimitAmount: 0,
      weeklyLimitLiters: el.maxLiters, weeklyLimitAmount: 0, monthlyLimitLiters: 0,
      monthlyLimitAmount: 0, fixedMonthlyLimitLiters: 0, fixedMonthlyLimitAmount: 0,
      maxDailyLoads: 0, checkDaylyLiters: false, checkDaylyAmount: false,
      checkWeeklyLiters: true, checkWeeklyAmount: false, checkMonthlyLiters: false,
      checkMonthlyAmount: false, dailyLiters: 0, dailyAmount: 0, weeklyLiters: el.maxLiters,
      weeklyAmount: 0, monthlyLiters: 0, monthlyAmount: 0, dailyLoads: 0,
      sundaySchedule: undefined, mondaySchedule: undefined, tuesdaySchedule: undefined,
      wednesdaySchedule: undefined, thursdaySchedule: undefined, fridaySchedule: undefined,
      saturdaySchedule: undefined, specialShiftCollection: [], previousOdometer: 0,
      currentOdometer: 0, previousFirstStrap: '', currentFirstStrap: '',
      previousSecondStrap: '', currentSecondStrap: '', litersPerHour: 0,
      sundayFullTank: false, mondayFullTank: false, tuesdayFullTank: false,
      wednesdayFullTank: false, thursdayFullTank: false, fridayFullTank: false,
      saturdayFullTank: false, cardType: 0, vehicleFullNumber: '', vehicleDescription: '',
      nameUser: this.data.UserType === 'Administrator' ? 'Administrador de la cuenta' : this.data.Name,
      photoTypeList: [], hasLoadSchedule: false,
      deliveryId: el.requireHologram ? parseInt(this.deliveryMethod) : 0,
      isPhysicalcardEnabled: false, platesExtra: el.plate2, cardNumber: '', user: '',
      vehicle: 0, economicNum: el.ecoNumber, vehicleType: '', portalLoadType: true
    } as any));

    this.service.addDevices(devicesRequest, this.data.Client_number, this.data.User_id > 0 ? this.data.Name : 'Administrador de la cuenta').subscribe({
      next: (resp: any) => {
        this.isSaving = false;
        if (resp.code !== 0) {
          this.devices = [];
          this.formDevice.reset();
          const msg = resp.idNotificacion > 0
            ? 'Dispositivos agregados. Solicitud de impresión #' + resp.idNotificacion
            : 'Los dispositivos han sido agregados a su catálogo';
          this.toastSrv.add({ type: 'success', message: msg });
        } else {
          this.toastSrv.add({ type: 'error', message: 'Hubo un problema al dar de alta las unidades' });
        }
      },
      error: (err: any) => {
        this.isSaving = false;
        this.toastSrv.add({ type: 'error', message: err.error?.error || 'Error al procesar la solicitud' });
      }
    });
  }
}
